import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import logo from '../../Assets/despar.jpg'
import { colors, layout, bp } from '../../theme'

const Main = styled.nav`
  width: 100%;
  background: ${colors.white};
  border-bottom: 1px solid ${colors.line};
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`

const Container = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
  height: 4.75rem;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${bp.mobile}) {
    padding: 0 1rem;
    height: 4.25rem;
  }
`

const LogoSection = styled.a`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  text-decoration: none;
`

const LogoImg = styled.img`
  height: 44px;
  width: auto;
  object-fit: contain;

  @media (max-width: ${bp.mobile}) {
    height: 38px;
  }
`

const Brand = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    margin: 0;
    color: ${colors.green};
    font-size: 1.05rem;
    font-weight: 800;
    letter-spacing: 0.3px;
  }

  span {
    color: ${colors.slate};
    font-size: 0.74rem;
  }

  @media (max-width: ${bp.mobile}) {
    h2 { font-size: 0.92rem; }
    span { font-size: 0.66rem; }
  }
`

const MenuButton = styled.button`
  display: none;
  border: none;
  background: transparent;
  color: ${colors.green};
  font-size: 1.8rem;
  cursor: pointer;

  @media (max-width: ${bp.tablet}) {
    display: block;
  }
`

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;

  @media (max-width: ${bp.tablet}) {
    position: absolute;
    top: 4.75rem;
    left: 0;
    width: 100%;
    background: ${colors.white};
    border-bottom: 1px solid ${colors.line};
    flex-direction: column;
    align-items: stretch;
    padding: ${({ open }) => (open ? '0.75rem 1rem' : '0 1rem')};
    max-height: ${({ open }) => (open ? '420px' : '0')};
    overflow: hidden;
    transition: all 0.3s ease;
  }
`

const NavItem = styled.a`
  text-decoration: none;
  color: ${colors.ink};
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.55rem 0.9rem;
  border-radius: 8px;
  transition: 0.2s ease;

  &:hover {
    background: ${colors.greenLight};
    color: ${colors.green};
  }
`

const LoginBtn = styled(Link)`
  text-decoration: none;
  color: ${colors.white};
  background: ${colors.green};
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  margin-left: 0.4rem;
  transition: 0.2s ease;

  &:hover {
    background: ${colors.greenDark};
  }

  @media (max-width: ${bp.tablet}) {
    margin-left: 0;
    text-align: center;
  }
`

const links = [
  { label: 'Products', href: '#products' },
  { label: 'Smart Dispenser', href: '#dispenser' },
  { label: 'Who We Serve', href: '#who-we-serve' },
  { label: 'Impact', href: '#impact' },
  { label: 'Contact', href: '#contact' },
]

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <Main>
      <Container>
        <LogoSection href="#top">
          <LogoImg src={logo} alt="Despar Clean logo" />
          <Brand>
            <h2>DESPAR CLEAN</h2>
            <span>Detergent &amp; Smart-Dispenser Manufacturer</span>
          </Brand>
        </LogoSection>

        <MenuButton onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          ☰
        </MenuButton>

        <NavLinks open={menuOpen}>
          {links.map((l) => (
            <NavItem key={l.href} href={l.href} onClick={() => setMenuOpen(false)}>
              {l.label}
            </NavItem>
          ))}
          <LoginBtn to="/login" onClick={() => setMenuOpen(false)}>
            Dashboard Login
          </LoginBtn>
        </NavLinks>
      </Container>
    </Main>
  )
}

export default Nav
